import { afterNextRender, ChangeDetectionStrategy, Component, ElementRef, inject, input, signal } from '@angular/core';

export type OverlapDirection = 'ltr' | 'rtl';

@Component({
    selector: 'tran-pill-row',
    template: '<ng-content></ng-content>',
    host: {
        '[class]': 'computedClasses()',
        '[attr.data-overlap-direction]': 'overlapDirection()'
    },
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PillRowComponent {
    private readonly elementRef = inject(ElementRef);

    public readonly overlapDirection = input<OverlapDirection>('ltr');
    public readonly rowClasses = input<string>('');

    protected readonly computedClasses = signal<string>('flex flex-nowrap items-stretch min-h-[60px]');

    constructor() {
        afterNextRender(() => {
            const table = this.elementRef.nativeElement.closest('tran-pill-table');
            const tableRowClasses = table?.getAttribute('data-table-row-classes') || '';
            const additional = this.rowClasses();

            // Check if a min-h class is already provided
            const hasMinHeight = /min-h-\[/.test(additional) || /min-h-\[/.test(tableRowClasses);
            const baseClasses = hasMinHeight
                ? 'flex flex-nowrap items-stretch'
                : 'flex flex-nowrap items-stretch min-h-[60px]';

            const allClasses = [baseClasses, tableRowClasses, additional].filter(Boolean).join(' ');

            this.computedClasses.set(allClasses);
        });
    }
}
